// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.confirm-registration-email-modal__email {
  color: var(--primary-color);
  padding: 0.5rem 0 1rem;
  text-align: center;
}
.confirm-registration-email-modal__button-confirm {
  color: var(--email-confirmation-button-color) !important;
  background-color: var(--email-confirmation-button-bg-color) !important;
  border-color: var(--email-confirmation-button-border-color) !important;
}
.confirm-registration-email-modal__button-confirm:hover {
  color: var(--email-confirmation-button-color-hover) !important;
  background-color: var(--email-confirmation-button-bg-color-hover) !important;
  border-color: var(--email-confirmation-button-border-color-hover) !important;
}`, "",{"version":3,"sources":["webpack://./src/components/modals/ConfirmEmailOnRegister/ConfirmEmailOnRegister.scss"],"names":[],"mappings":"AACI;EACI,2BAAA;EACA,sBAAA;EACA,kBAAA;AAAR;AAGI;EACI,wDAAA;EACA,sEAAA;EACA,sEAAA;AADR;AAGQ;EACI,8DAAA;EACA,4EAAA;EACA,4EAAA;AADZ","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
